import { UAAppResources } from '@unifyapps/defs/types/apps';
import type { ExecuteWorkflowNodeRequest } from '@unifyapps/network/generated/models/executeWorkflowNodeRequest';
import { executeWorkflowNode } from '../api';
import type { DebugParams } from '../types';

type OperationFunction = (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  debugParams: DebugParams,
) => Promise<unknown>;

type ModuleLoader = () => Promise<{ default: OperationFunction }>;

const UA_RESOURCE_VS_QUERY_FN: Record<string, ModuleLoader> = {
  [UAAppResources.CustomHttpEndpointExecute]: () =>
    import('./operationQueryFn/executeCustomHTTPRest'),
};

const clientDirectApi = async (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  debugParams: DebugParams,
) => {
  const resourceName = executeWorkflowNodeRequest.context?.resourceName as
    | UAAppResources
    | undefined;

  if (!resourceName) {
    return executeWorkflowNode(executeWorkflowNodeRequest, debugParams);
  }

  const moduleLoader = UA_RESOURCE_VS_QUERY_FN[resourceName];

  try {
    const { default: operationFunction = executeWorkflowNode } = await moduleLoader();
    return await operationFunction(executeWorkflowNodeRequest, debugParams);
  } catch (error) {
    console.error(
      `Error loading or executing datasource on client ${executeWorkflowNodeRequest.id ?? ''}:`,
      error,
    );
    throw error;
  }
};

export default clientDirectApi;
